import { smb_fetch, getAgpAgmsApiUrl } from '@/api/operator/fetch';

export const showPassiveAccSummary = () => {
  const url = getAgpAgmsApiUrl('passive_accumulation', 'show_menu');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data: {},
  }, false, false);
};

export const getPassiveAccSummary = () => {
  const url = getAgpAgmsApiUrl('passive_accumulation', 'summary');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data: {},
  }, false, false);
};

export const getPassiveAccList = (data: any) => {
  const url = getAgpAgmsApiUrl('passive_accumulation', 'list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    ...data,
  }, true, false).then((res: any) => {
    const { data } = res || {};
    return {
      ...res,
      data: {
        list: data?.list || [],
        conf: {
          total_num: data?.total || 0,
        },
      },
    };
  });
};

export const reportPassiveAccDownload = (data: any) => {
  const url = getAgpAgmsApiUrl('passive_accumulation', 'download/report');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, false, false);
};
